import ValidateEntityObject from '@/shared/utils/validate-entity-object';
import DirectiveDefinition from './directive-definition.entity';
import WorkItemType from '../work-item/work-item-type.entity';

export default class ProjectDirectives {
  private workItemType?: WorkItemType;

  private definitions?: DirectiveDefinition[];

  constructor(obj: any = {}) {
    this.workItemType = ValidateEntityObject.validate(obj.workItemType, WorkItemType.of);
    this.definitions = obj.definitions;
  }

  public static of(value: any): ProjectDirectives {
    return new ProjectDirectives(value || {});
  }

  public static ofList(response: any): ProjectDirectives[] {
    return response.map(this.of);
  }
}
